import { render, staticRenderFns } from "./MoveCorrespondences.vue?vue&type=template&id=5ba977bc&scoped=true"
import script from "./MoveCorrespondences.vue?vue&type=script&lang=js"
export * from "./MoveCorrespondences.vue?vue&type=script&lang=js"
import style0 from "./MoveCorrespondences.vue?vue&type=style&index=0&id=5ba977bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba977bc",
  null
  
)

export default component.exports